var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMintFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97217 20.3455C5.00925 20.3455 2.59883 17.9349 2.59883 14.9722C2.59883 14.4491 2.67522 13.944 2.81522 13.4656C4.1605 14.742 5.97578 15.5277 7.97217 15.5277C9.96856 15.5277 11.7838 14.742 13.1291 13.4656C13.2691 13.944 13.3455 14.4491 13.3455 14.9722C13.3455 17.9349 10.9351 20.3455 7.97217 20.3455ZM0.472168 8.02772C0.472168 9.28008 0.782307 10.4609 1.32758 11.4999C0.782307 12.5388 0.472168 13.7197 0.472168 14.9722C0.472168 19.1076 3.83675 22.4722 7.97217 22.4722C12.1076 22.4722 15.4722 19.1076 15.4722 14.9722C15.4722 13.7197 15.162 12.5388 14.6168 11.4999C15.162 10.4609 15.4722 9.28008 15.4722 8.02772C15.4722 3.89217 12.1076 0.527723 7.97217 0.527723C3.83675 0.527723 0.472168 3.89217 0.472168 8.02772Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMintFee);
export default __webpack_public_path__ + "static/media/icon-mint-fee.d59b8085.svg";
export { ForwardRef as ReactComponent };